import { TRegionKey } from '@source/interface';
import {
  NEXT_PUBLIC_ALGOLIA_APP_ID,
  NEXT_PUBLIC_ALGOLIA_SHOWROOM_NEW_SG,
  NEXT_PUBLIC_ALGOLIA_NEW_CAR_SG,
  NEXT_PUBLIC_ALGOLIA_API_KEY_SG,
  NEXT_PUBLIC_ALGOLIA_POPULAR_NEW_CAR_SG,
} from '@source/constants/env';

const algoliaIndexesSG = {
  latest: {
    asc: `${NEXT_PUBLIC_ALGOLIA_SHOWROOM_NEW_SG}_sort_newest`,
    desc: `${NEXT_PUBLIC_ALGOLIA_SHOWROOM_NEW_SG}_sort_newest`,
  },
  price: {
    asc: `${NEXT_PUBLIC_ALGOLIA_SHOWROOM_NEW_SG}_sort_price_asc`,
    desc: `${NEXT_PUBLIC_ALGOLIA_SHOWROOM_NEW_SG}_sort_price_desc`,
  },
  depreciation: {
    asc: `${NEXT_PUBLIC_ALGOLIA_SHOWROOM_NEW_SG}_sort_depreciation_asc`,
    desc: `${NEXT_PUBLIC_ALGOLIA_SHOWROOM_NEW_SG}_sort_depreciation_desc`,
  },
  mileage: {
    asc: `${NEXT_PUBLIC_ALGOLIA_SHOWROOM_NEW_SG}_sort_mileage_asc`,
    desc: `${NEXT_PUBLIC_ALGOLIA_SHOWROOM_NEW_SG}_sort_mileage_desc`,
  },
  instalment: {
    asc: `${NEXT_PUBLIC_ALGOLIA_SHOWROOM_NEW_SG}_sort_installment_asc`,
    desc: `${NEXT_PUBLIC_ALGOLIA_SHOWROOM_NEW_SG}_sort_installment_desc`,
  },
  reg_year: {
    asc: `${NEXT_PUBLIC_ALGOLIA_SHOWROOM_NEW_SG}_sort_registration_year_asc`,
    desc: `${NEXT_PUBLIC_ALGOLIA_SHOWROOM_NEW_SG}_sort_registration_year_desc`,
  },
};

export const ALGOLIA_INDEXES_NEW_CARS_COUNTRIES = {
  sg: algoliaIndexesSG,
  my: '',
  id: '',
  th: '',
  jp: '',
  hk: '',
};

export const ALGOLIA_INDEXES_COUNTRIES = {
  sg: NEXT_PUBLIC_ALGOLIA_NEW_CAR_SG,
  my: '',
  id: '',
  th: '',
  jp: '',
  hk: '',
};

export const ALGOLIA_API_KEY_MAP: Record<TRegionKey, string | undefined> = {
  sg: NEXT_PUBLIC_ALGOLIA_API_KEY_SG,
  my: '',
  id: '',
  th: '',
  jp: '',
  hk: '',
};

export const ALGOLIA_INDEX_POPULAR_NEW_BY_COUNTRY: { [key: string]: string } = {
  sg: NEXT_PUBLIC_ALGOLIA_POPULAR_NEW_CAR_SG || '',
  my: '',
  id: '',
  th: '',
  jp: '',
  hk: '',
};

export const ALGOLIA_APP_ID = NEXT_PUBLIC_ALGOLIA_APP_ID;
